(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["related-colors"] && !Shopify.designMode) return;
  try {
    class RelatedColorsPicker extends HTMLElement {
  constructor() {
    super();
    this.swatches = this.querySelectorAll('.related-colors__swatch');
    this.productCard = this.closest('product-card') || this.closest('.product-card');
    this.cachedElements = null;
    this.videoCache = new Map();
    this.init();
  }

  init() {
    this.cacheElements();
    this.swatches.forEach(swatch => {
      swatch.addEventListener('click', (e) => this.handleSwatchClick(e, swatch));
      
      swatch.addEventListener('mouseenter', () => {
        if (this.productCard) {
          this.productCard.setAttribute('data-previewing-variant', 'true');
        }
      });
      swatch.addEventListener('mouseleave', () => {
        if (this.productCard) {
          this.productCard.removeAttribute('data-previewing-variant');
        }
      });
    });

    this.setupCardHover();
  }

  setupCardHover() {
    if (!this.productCard) return;
    
    const cardGallery = this.productCard.querySelector('.card-gallery');
    if (!cardGallery) return;

    cardGallery.addEventListener('pointerenter', (e) => {
      if (e.pointerType !== 'mouse') return;
      this.handleCardHover();
    });

    cardGallery.addEventListener('pointerleave', (e) => {
      if (e.pointerType !== 'mouse') return;
      this.handleCardHoverEnd();
    });
  }

  handleCardHover() {
    const selectedSwatch = this.querySelector('.related-colors__swatch--selected');
    if (!selectedSwatch) return;

    const hoverImageUrl = selectedSwatch.dataset.productHoverImage;
    if (!hoverImageUrl) return;

    if (!this.cachedElements) {
      this.cacheElements();
    }
    const el = this.cachedElements;
    if (!el) return;

    // Compare files, not URLs: the card's own hover image differs only in width, and swapping it discarded
    // the preloaded copy so the card showed white while the new URL downloaded
    const hoverFile = new URL(hoverImageUrl, location.href).pathname;
    const updateSecondImage = (imgElement) => {
      if (imgElement && new URL(imgElement.currentSrc || imgElement.src, location.href).pathname !== hoverFile) {
        imgElement.src = hoverImageUrl;
        imgElement.srcset = hoverImageUrl;
      }
    };

    if (el.secondImg) {
      updateSecondImage(el.secondImg);
    }

    if (el.secondSlide) {
      const secondSlideImg = el.secondSlide.querySelector('img:not(video img, template img)');
      if (secondSlideImg) {
        updateSecondImage(secondSlideImg);
      }
    }

    // Card videos are shown by ProductCard.previewImage once they are actually playing
    if (el.secondSlide?.querySelector('deferred-media[data-defer-until-visible]')) return;

    const slideshow = this.productCard?.querySelector('slideshow-component');
    if (slideshow && el.secondSlide && slideshow.slides && slideshow.slides.length > 1) {
      if (el.secondSlide.style.visibility === 'hidden') {
        el.secondSlide.style.visibility = '';
        el.secondSlide.style.opacity = '';
      }
      
      const secondSlideIndex = Array.from(slideshow.refs.slides || []).indexOf(el.secondSlide);
      if (secondSlideIndex >= 0 && slideshow.current !== secondSlideIndex) {
        slideshow.select(secondSlideIndex, undefined, { animate: false });
      }
    }
  }

  handleCardHoverEnd() {
    const el = this.cachedElements;
    if (!el) return;

    const slideshow = this.productCard?.querySelector('slideshow-component');
    if (slideshow && slideshow.current > 0) {
      slideshow.select(0, undefined, { animate: false });
    }
  }

  cacheElements() {
    if (!this.productCard) return;
    const slides = this.productCard.querySelectorAll('slideshow-slide');
    const titleLink = this.productCard.querySelector('[ref="productTitleLink"]');
    const secondSlide = slides[1];
    const deferredMedia = secondSlide?.querySelector('deferred-media');
    const video = deferredMedia?.querySelector('video:not(template video)') || secondSlide?.querySelector('video:not(template video)');
    const videoTemplate = deferredMedia?.querySelector('template video');
    
    this.cachedElements = {
      link: this.productCard.querySelector('.product-card__link, a[href*="/products/"]'),
      slideLinks: this.productCard.querySelectorAll('slideshow-slide a, .card-gallery a'),
      firstImg: slides[0]?.querySelector('img') || this.productCard.querySelector('.card-gallery img, .product-card__image img'),
      secondImg: slides[1]?.querySelector('img') || this.productCard.querySelectorAll('.card-gallery img, .product-card__image img')[1],
      secondSlide: secondSlide,
      deferredMedia: deferredMedia,
      video: video,
      videoTemplate: videoTemplate,
      titleLink: titleLink,
      title: titleLink?.querySelector('p') || this.productCard.querySelector('.text-block p'),
      price: this.productCard.querySelector('.price__current, .product-price, [class*="price"]')
    };
  }

  handleSwatchClick(e, swatch) {
    e.preventDefault();
    if (swatch.classList.contains('related-colors__swatch--selected')) return;

    const oldProductId = this.productCard?.dataset?.productId;

    if (this.cachedElements && this.cachedElements.video) {
      this.cachedElements.video.pause();
      this.cachedElements.video.currentTime = 0;
      this.cachedElements.video.setAttribute('data-updating', 'true');
    }
    if (this.cachedElements && this.cachedElements.deferredMedia) {
      try {
        if (typeof this.cachedElements.deferredMedia.pauseMedia === 'function') {
          this.cachedElements.deferredMedia.pauseMedia();
        }
        this.cachedElements.deferredMedia.setAttribute('data-updating', 'true');
      } catch (err) {}
    }
    if (this.cachedElements && this.cachedElements.secondSlide && (this.cachedElements.video || this.cachedElements.deferredMedia)) {
      this.cachedElements.secondSlide.style.visibility = 'hidden';
      this.cachedElements.secondSlide.style.opacity = '0';
      this.cachedElements.secondSlide.setAttribute('data-updating-video', 'true');
    }

    this.swatches.forEach(s => {
      s.classList.remove('related-colors__swatch--selected');
      s.removeAttribute('aria-current');
    });
    swatch.classList.add('related-colors__swatch--selected');
    swatch.setAttribute('aria-current', 'true');

    this.updateCard(swatch.dataset, oldProductId);
  }

  updateCard(d, oldProductId = null) {
    const el = this.cachedElements;
    if (!el) return;

    if (!oldProductId) {
      oldProductId = this.productCard?.dataset?.productId;
    }

    if (el.link) el.link.href = d.productUrl;
    if (el.titleLink) el.titleLink.href = d.productUrl;
    el.slideLinks?.forEach(sl => sl.href = d.productUrl);

    if (el.firstImg) {
      el.firstImg.src = d.productImage;
      el.firstImg.srcset = d.productImage;
    }
    if (el.secondImg && d.productHoverImage) {
      el.secondImg.src = d.productHoverImage;
      el.secondImg.srcset = d.productHoverImage;
    }

    if (el.title) el.title.textContent = d.productTitle;
    if (el.price) {
      const priceSpan = el.price.querySelector('[data-product-price], .money') || el.price;
      if (priceSpan) priceSpan.textContent = d.productPrice;
    }

    if (this.productCard.dataset) this.productCard.dataset.productId = d.productId;
    
    if (el.secondSlide && (el.video || el.deferredMedia)) {
      this.updateVideo(d.productUrl, d.productId, oldProductId);
    } else if (el.secondSlide) {
      el.secondSlide.style.visibility = '';
      el.secondSlide.style.opacity = '';
      el.secondSlide.removeAttribute('data-updating-video');
    }
  }
  
  async updateVideo(productUrl, productId, oldProductId = null) {
    try {
      const cached = this.videoCache.get(productId);
      if (cached) {
        this.applyVideoUpdate(cached.url, cached.poster);
        return;
      }
      
      let videoUrl = null;
      let videoPoster = null;
      const productChanged = oldProductId && productId && oldProductId !== productId;
      
      if (!productChanged && oldProductId === productId) {
        const existingCard = document.querySelector(`product-card[data-product-id="${productId}"]`);
        if (existingCard) {
          const slideshow = existingCard.querySelector('slideshow-component');
          const secondSlide = slideshow?.querySelector('slideshow-slide:nth-child(2)');
          const deferredMedia = secondSlide?.querySelector('deferred-media');
          const videoTemplate = deferredMedia?.querySelector('template video');
          const videoSource = videoTemplate?.querySelector('source[type="video/mp4"]');
          videoUrl = videoSource?.getAttribute('src');
          videoPoster = videoTemplate?.getAttribute('poster');
          
          if (!videoUrl) {
            const loadedVideo = deferredMedia?.querySelector('video:not(template video)');
            if (loadedVideo) {
              const loadedSource = loadedVideo.querySelector('source[type="video/mp4"]');
              videoUrl = loadedSource?.getAttribute('src') || loadedVideo.getAttribute('src');
              videoPoster = loadedVideo.getAttribute('poster');
            }
          }
        }
      }
      
      if (!videoUrl || productChanged) {
        const url = new URL(productUrl, window.location.origin);
        const response = await fetch(url.href);
        
        if (!response.ok) {
          if (this.cachedElements.secondSlide) {
            this.cachedElements.secondSlide.style.visibility = '';
            this.cachedElements.secondSlide.style.opacity = '';
            this.cachedElements.secondSlide.removeAttribute('data-updating-video');
          }
          return;
        }
        
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        let slideshow = doc.querySelector(`product-card[data-product-id="${productId}"] slideshow-component`);
        
        if (!slideshow) {
          slideshow = doc.querySelector('.product__media slideshow-component, [class*="product"] slideshow-component, main slideshow-component');
        }
        
        if (!slideshow) {
          slideshow = doc.querySelector('slideshow-component');
        }
        
        if (slideshow) {
          const slides = slideshow.querySelectorAll('slideshow-slide');
          let videoSlide = null;
          
          for (let i = 0; i < slides.length; i++) {
            const slide = slides[i];
            const deferredMedia = slide.querySelector('deferred-media');
            const hasVideo = deferredMedia || slide.querySelector('video');
            if (hasVideo) {
              videoSlide = slide;
              break;
            }
          }
          
          if (!videoSlide && slides.length > 1) {
            videoSlide = slides[1];
          }
          
          if (videoSlide) {
            const deferredMedia = videoSlide.querySelector('deferred-media');
            
            if (deferredMedia) {
              const template = deferredMedia.querySelector('template');
              
              if (template) {
                const videoTemplate = template.querySelector('video');
                
                if (videoTemplate) {
                  const videoSource = videoTemplate.querySelector('source[type="video/mp4"]');
                  videoUrl = videoSource?.getAttribute('src');
                  videoPoster = videoTemplate.getAttribute('poster');
                }
              }
              
              if (!videoUrl) {
                const loadedVideo = deferredMedia.querySelector('video:not(template video)');
                
                if (loadedVideo) {
                  const loadedSource = loadedVideo.querySelector('source[type="video/mp4"]');
                  videoUrl = loadedSource?.getAttribute('src') || loadedVideo.getAttribute('src');
                  videoPoster = loadedVideo.getAttribute('poster');
                }
              }
            }
            
            if (!videoUrl && videoSlide) {
              const allVideos = videoSlide.querySelectorAll('video');
              for (const vid of allVideos) {
                const src = vid.querySelector('source[type="video/mp4"]')?.getAttribute('src') || vid.getAttribute('src');
                if (src) {
                  videoUrl = src;
                  videoPoster = vid.getAttribute('poster');
                  break;
                }
              }
            }
          }
        }
      }
      
      if (!videoUrl) {
        if (this.cachedElements.secondSlide) {
          this.cachedElements.secondSlide.style.display = 'none';
          this.cachedElements.secondSlide.removeAttribute('data-updating-video');
        }
        return;
      }
      
      this.videoCache.set(productId, { url: videoUrl, poster: videoPoster });
      this.applyVideoUpdate(videoUrl, videoPoster);
    } catch (error) {
      console.error('[RelatedColorsPicker] Error updating video:', error);
      if (this.cachedElements.secondSlide) {
        this.cachedElements.secondSlide.style.visibility = '';
        this.cachedElements.secondSlide.style.opacity = '';
        this.cachedElements.secondSlide.removeAttribute('data-updating-video');
      }
    }
  }
  
  applyVideoUpdate(videoUrl, videoPoster) {
    const el = this.cachedElements;
    
    if (el.deferredMedia) {
      try {
        if (typeof el.deferredMedia.pauseMedia === 'function') {
          el.deferredMedia.pauseMedia();
        }
      } catch (err) {}
      
      const template = el.deferredMedia.querySelector('template');
      if (template) {
        const templateVideo = template.querySelector('video');
        if (templateVideo) {
          templateVideo.removeAttribute('autoplay');
          
          const source = templateVideo.querySelector('source[type="video/mp4"]');
          if (source) {
            source.setAttribute('src', videoUrl);
          }
          
          if (videoPoster) {
            templateVideo.setAttribute('poster', videoPoster);
          }
          
          setTimeout(() => {
            templateVideo.setAttribute('autoplay', 'autoplay');
          }, 100);
        }
      }
    }
    
    if (el.video) {
      el.video.pause();
      el.video.currentTime = 0;
      el.video.removeAttribute('autoplay');
      
      const source = el.video.querySelector('source[type="video/mp4"]');
      if (source) {
        source.setAttribute('src', videoUrl);
        if (videoPoster) {
          el.video.setAttribute('poster', videoPoster);
        }
        el.video.load();
      } else {
        el.video.setAttribute('src', videoUrl);
        if (videoPoster) {
          el.video.setAttribute('poster', videoPoster);
        }
        el.video.load();
      }
    }
    
    if (el.secondSlide) {
      el.secondSlide.style.visibility = '';
      el.secondSlide.style.opacity = '';
    }
    
    if (el.video) {
      el.video.removeAttribute('data-updating');
    }
    if (el.deferredMedia) {
      el.deferredMedia.removeAttribute('data-updating');
    }
    if (el.secondSlide) {
      el.secondSlide.removeAttribute('data-updating-video');
      el.secondSlide.style.display = '';
    }
  }
}

if (!customElements.get('related-colors-picker')) {
  customElements.define('related-colors-picker', RelatedColorsPicker);
}
  } catch(e) { console.error(e); }
})();

})();
